import React from 'react';
import { Link } from 'react-router-dom';

//import images
import logoBOA from "../assets/images/logo_boa.png";

const Header = ({ headerClass } : any) => {

    const toogleMenuBtn = () => {
        //For collapse horizontal menu
        if (document.documentElement.getAttribute('data-layout') === "horizontal") {
            document.body.classList.contains("menu") ? document.body.classList.remove("menu") : document.body.classList.add("menu");
        }
    };

    return (
        <React.Fragment>
            <header id="page-topbar" className={headerClass}>
                <div className="layout-width">
                    <div className="navbar-header">
                        <div className="d-flex">

                            <div className="navbar-brand-box horizontal-logo">
                                <Link to="/" className="logo logo-dark">
                                    <span>
                                        <img src={logoBOA} alt="" height="45" />
                                    </span>
                                </Link>
                            </div>
                        </div>

                        <div className="d-flex align-items-center">

                            <Link to="https://www.bankofafrica.ma/" className="header-link" id='links' target="_blank" rel="noopener noreferrer">
                                <span className="d-flex align-items-center">
                                    <span className="rounded-circle header-profile-user"><i className='bx bx-link-external fs-18' style={{margin: '7px'}}></i></span>
                                    <span className="text-start ms-xl-2">
                                        <span className="d-none d-lg-inline-block ms-1 fw-medium user-name-text"> Site commercial</span>
                                    </span>
                                </span>
                            </Link>
                            <Link to="https://scf-bankofafrica.ma/" className="header-link" id='links' target="_blank" rel="noopener noreferrer">
                                <span className="d-flex align-items-center">
                                    <span className="rounded-circle header-profile-user"><i className='bx bx-link-external fs-18' style={{margin: '7px'}}></i></span>
                                    <span className="text-start ms-xl-2">
                                        <span className="d-none d-lg-inline-block ms-1 fw-medium user-name-text"> Supply Chain Finance</span>
                                    </span>
                                </span>
                            </Link>
                            <button
                                onClick={toogleMenuBtn}
                                type="button"
                                className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
                                id="topnav-hamburger-icon">
                                <span className="hamburger-icon">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </span>
                            </button>
                        </div>

                            
                    </div>
                </div>
            </header>
        </React.Fragment>
    );
};

export default Header;